import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const creditBookingId = params.get("credit") === "1" ? params.get("booking_id") : null;
  const [status, setStatus] = useState("checking");
  const [bookingId, setBookingId] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [giftCard, setGiftCard] = useState(null);

  useEffect(() => {
    if (creditBookingId) { setBookingId(creditBookingId); setStatus("paid"); return; }
    if (!sid) { setStatus("error"); return; }
    let tries = 0; let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setBookingId(data.booking_id); setJobId(data.job_id); setOrderId(data.order_id); setGiftCard(data.gift_card_id);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries++ >= 10) { setStatus("timeout"); return; }
        timer = setTimeout(poll, 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, creditBookingId]);

  return (
    <main className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="glass rounded-3xl p-10 max-w-md text-center rise">
        {status === "checking" ? (
          <>
            <Loader2 className="w-10 h-10 text-cyan-400 animate-spin mx-auto mb-4" />
            <p className="text-slate-300">Confirming your payment…</p>
          </>
        ) : status === "paid" ? (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 border-2 border-emerald-500 flex items-center justify-center mx-auto mb-5">
              <Check className="w-8 h-8 text-emerald-400" strokeWidth={3} />
            </div>
            <h1 className="font-display text-3xl font-extrabold mb-2">{giftCard ? "Gift card sent" : orderId ? "Order confirmed" : jobId ? "Delivery job posted" : "Booking confirmed"}</h1>
            <p className="text-slate-300 mb-6">{giftCard ? "Payment received. If you picked a delivery date, it'll arrive that morning at 9am ET — otherwise we've emailed the recipient already. Members get the credit instantly; new members claim it when they sign up." : orderId ? "Thanks! Raq emailed your receipt. Track shipping and digital items on your orders page." : jobId ? "Your run is live on the board. We'll email you when a verified driver claims it." : "Pickup details are in your dashboard."}</p>
            <Link to={orderId ? "/orders" : jobId ? "/delivery" : "/dashboard"}><Button data-testid="success-go-dashboard" className="bg-white text-slate-950 hover:bg-slate-100 font-semibold">{orderId ? "View my orders" : jobId ? "View delivery board" : "Go to dashboard"}</Button></Link>
          </>
        ) : (
          <>
            <p className="text-slate-300 mb-4">We couldn't confirm the payment yet. Please check your dashboard.</p>
            <Link to="/dashboard"><Button variant="outline" className="bg-transparent border-slate-700">Open dashboard</Button></Link>
          </>
        )}
      </div>
    </main>
  );
}
